export default {
  openapp: "打开APP",
  noStore: "门店不存在",
  rating: "评分:",
  DeliveryFee: "配送费",
  FreeDelivery:"免配送费",
  deducedeliveryfee :'减配送费',
  noScore: '暂无评分',
  discountTitle: '折扣',
  fullReductionTitle: '满减',
  storeFirstTitle: '首单',
  promotionTitle: '优惠活动',
  StoreAnnouncement:'门店公告',
  Businesshours: '营业时间',
  DeliveryScope:'经营范围',
  PaymentMethod: '付款方式',
  goAppTip: '前往大象APP，享受更多优惠',
  CashonDelivery: '货到付款',
  PayOnline: '线上支付',
  availablecoupons: '门店优惠券',
  Get: '领',
  refresh: '刷新页面',
  MONDAY: '周一',
  TUESDAY: '周二',
  WEDNESDAY: '周三',
  THURSDAY: '周四',
  FRIDAY: '周五',
  SATURDAY: '周六',
  SUNDAY: '周日',
  MerchantService: '商家服务'
}